module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAQBAMAAAD+CqKmAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAhUExURUdwTDIyMjAwMDMzMzMzMzAwMDU1NUBAQDMzMzMzMzMzM+TxfSIAAAAKdFJOUwDfIM+gEDAQUL8PqTVAAAAATElEQVQI12NgwA0qYIwkIJYyhbBZFoI4iwPAHC8QR3EVWIpllRCQZIJIeS1UYIBJQSSgUlAJsBRMAiw1CyYBkoJLgKQQEkApIQb8AACGIRHsI3ZIWAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jjfa/years/收起@2x2.png
// module id = gQ//
// module chunks = 1